import * as React from 'react';
import { AlertTriangle, RefreshCcw } from 'lucide-react';

import { Alert, AlertDescription, AlertTitle } from '@/shared/ui/alert';
import { Button } from '@/shared/ui/button';

interface DashboardErrorProps {
  message?: string;
  onRetry?: () => void;
}

/**
 * Error state for dashboards. Reused by every dashboard page.
 */
export function DashboardError({ message, onRetry }: DashboardErrorProps) {
  return (
    <Alert variant="destructive" className="tw-flex tw-flex-col tw-gap-3">
      <AlertTriangle className="tw-h-4 tw-w-4" />
      <AlertTitle>Could not load dashboard</AlertTitle>
      <AlertDescription>
        {message ?? 'An unexpected error occurred while loading dashboard data.'}
      </AlertDescription>
      {onRetry ? (
        <div className="tw-mt-2">
          <Button
            type="button"
            variant="outline"
            size="sm"
            onClick={onRetry}
          >
            <RefreshCcw className="tw-mr-2 tw-h-3.5 tw-w-3.5" />
            Retry
          </Button>
        </div>
      ) : null}
    </Alert>
  );
}
